import React from 'react'
import OurProducts from "../Home/OurProducts"

export default function Products() {
  return (
    <div className=''>

         {/* Banner Section */}
         <div className='md:h-[80vh] h-[60vh] relative'>
          <h2 className='bg-transparent pt-72 z-30 absolute text-white md:pl-48 md:text-8xl text-5xl'>
         Our Products
          </h2>
          <div className='md:h-[80vh] h-[60vh] bg-black opacity-50 w-full absolute z-20'></div>
          <img
            src='./Products/products.jpeg'
            alt='Contact Us Banner'
            className='h-full w-full object-cover'
          />
        </div>
      {/* <h1>Hello, This are Products</h1> */}
      <OurProducts/>
    </div>
  )
}
